const GameOverModal = ({ result, stats, modelName = 'MasterGemi', onPlayAgain, onMainMenu, onClose }) => {
  const getResultInfo = () => {
    switch (result) {
      case 'win':
        return {
          icon: '👑',
          title: 'Victory!',
          message: `You defeated ${modelName}!`,
          color: 'text-green-500'
        };
      case 'loss':
        return {
          icon: '😔',
          title: 'Defeat',
          message: `${modelName} wins this round`,
          color: 'text-red-500'
        };
      case 'draw':
        return {
          icon: '🤝',
          title: 'Draw',
          message: 'A well-fought match',
          color: 'text-gray-400'
        };
      default:
        return {
          icon: '♟',
          title: 'Game Over',
          message: '',
          color: 'text-white'
        };
    }
  };

  const resultInfo = getResultInfo();

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-dark-background border-2 border-dark-border p-8 max-w-md w-full shadow-brutal">
        {/* Icon & Title */}
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">{resultInfo.icon}</div>
          <h2 className={`text-3xl font-bold mb-2 ${resultInfo.color}`}>
            {resultInfo.title}
          </h2>
          <p className="text-gray-400">{resultInfo.message}</p>
        </div>

        {/* Stats */}
        <div className="bg-gray-800 border-2 border-gray-700 p-4 mb-6">
          <h3 className="text-white font-bold mb-3 text-center">Your Stats</h3>
          <div className="flex justify-around">
            <div className="text-center">
              <div className="text-green-500 text-2xl font-bold">{stats.wins}</div>
              <div className="text-gray-400 text-sm">Wins</div>
            </div>
            <div className="text-center">
              <div className="text-red-500 text-2xl font-bold">{stats.losses}</div>
              <div className="text-gray-400 text-sm">Losses</div>
            </div>
            <div className="text-center">
              <div className="text-gray-400 text-2xl font-bold">{stats.draws}</div>
              <div className="text-gray-400 text-sm">Draws</div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <button 
            onClick={onPlayAgain}
            className="w-full py-3 bg-green-600 hover:bg-green-700 text-white border-2 border-green-500 font-bold transition-all hover:shadow-brutal"
          >
            Play Again
          </button>
          <button 
            onClick={onMainMenu}
            className="w-full py-3 bg-gray-700 hover:bg-gray-600 text-white border-2 border-gray-600 font-bold transition-all hover:shadow-brutal"
          >
            Return to Main Menu
          </button>
          <button 
            onClick={onClose}
            className="w-full py-3 bg-transparent hover:bg-gray-800 text-gray-400 border-2 border-gray-600 font-bold transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOverModal;
